import { render, staticRenderFns } from "./highThreshold-editor.vue?vue&type=template&id=13d07d40&scoped=true"
import script from "./highThreshold-editor.vue?vue&type=script&lang=js"
export * from "./highThreshold-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d07d40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13d07d40')) {
      api.createRecord('13d07d40', component.options)
    } else {
      api.reload('13d07d40', component.options)
    }
    module.hot.accept("./highThreshold-editor.vue?vue&type=template&id=13d07d40&scoped=true", function () {
      api.rerender('13d07d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-rate/highThreshold-editor.vue"
export default component.exports